export const tooltipTheme = {
    paper: {
        background: (props) => props.theme.palette.overlayDark2,
        color: (props) => props.theme.palette.overlayLight,
        border: { radius: (props) => props.theme.radius.md },
        padding: (props) => props.theme.spacing.xs,
        byMaxWidth: {
            sm: { maxWidth: '100px' },
            md: { maxWidth: '200px' },
            lg: { maxWidth: '300px' },
            xl: { maxWidth: '500px' },
            none: { maxWidth: 'none' },
        },
        byFontSize: {
            sm: { fontSize: (props) => props.theme.font.size.xxs },
            md: { fontSize: (props) => props.theme.font.size.xs },
            lg: { fontSize: (props) => props.theme.font.size.sm },
            xl: { fontSize: (props) => props.theme.font.size.md },
        },
        transition: {
            duration: '200ms',
        },
    },
};
export const maxWidthVariant = (maxWidth = 'none') => tooltipTheme.paper.byMaxWidth[maxWidth];
export const fontSizeVariant = (maxWidth = 'sm') => tooltipTheme.paper.byFontSize[maxWidth];
